export default __webpack_public_path__ + "static/media/sc9.a08eb0a9.jpg";